import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useSearchParamsModal } from '../../../../../../components/modal/useSearchParamsModal';
import { Column } from '../../../../../../components/grid/Grid';
import { SearchQuerySectionPreparatoryWork } from '../../components/search-query-section/preparatory-work/SearchQuerySectionPreparatoryWork';
import { SearchModal } from '../../components/search-modal/SearchModal';

import { transformCount } from '../../utils/utils';
import { LegislationContextType } from '../../../../legislation.types';

type Props = {
  preparatoryWork: LegislationContextType['preparatoryWork'];
  articleTitle: string;
  articleIds: string[];
  articleId: string;
  initialVersionId: string;
  textNature: string;
};

export const PreparatoryWork: FC<Props> = ({
  preparatoryWork,
  articleTitle,
  articleIds,
  articleId,
  initialVersionId,
  textNature,
}) => {
  useSearchParamsModal('preparatory-work', (modalProps) => (
    <SearchModal
      restrictedIds={articleIds}
      title={articleTitle}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...modalProps}
    />
  ));

  if (!preparatoryWork.data) return null;

  return (
    <>
      <Column medium={4}>
        <h2>
          <FormattedMessage
            id="page/sections/PreparatoryWork/PreparatoryWork.tsx/1"
            values={{
              count: transformCount(preparatoryWork.data.totalHits),
            }}
          />
        </h2>
      </Column>
      <Column medium={8}>
        <SearchQuerySectionPreparatoryWork
          preparatoryWork={preparatoryWork}
          articleTitle={articleTitle}
          articleIds={articleIds}
          articleId={articleId}
          textNature={textNature}
          initialVersionId={initialVersionId}
        />
      </Column>
    </>
  );
};
